import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

export const getCivitModelVersionsByNumericalId = async (civitModelUrl: string) => {
  const civitId = civitModelUrl.split('/').filter((part) => /^\d+$/.test(part))[0];
  if (!civitId) return null;
  const res = await safeAxios.get<{ modelVersions: { id: string }[]; name: string }>(
    API_ROUTES.models.civit({ civitId }),
  );
  return res.data;
};

export const getCivitModelByVersionId = async (versionId: string) => {
  const res = await safeAxios.get<{
    air: string;
    images: { url: string }[];
  }>(API_ROUTES.models.civitVersion({ versionId }));
  return res.data;
};
